export const buildPortalEmptyStateContent = t => [
  {
    id: 1,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.SSL_CERTIFICATE.TITLE'),
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Michael' },
    category: {
      slug: 'configuration',
      icon: '📦',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.SETUP.NAME'),
    },
    views: 3400,
  },
  {
    id: 2,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.FIRST_PORTAL.TITLE'),
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'John' },
    category: {
      slug: 'onboarding',
      icon: '🧑‍🍳',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.ONBOARDING.NAME'),
    },
    views: 400,
  },
  {
    id: 3,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.ORGANIZE_CONTENT.TITLE'),
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Fernando' },
    category: {
      slug: 'best-practices',
      icon: '⛺️',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.BEST_PRACTICES.NAME'),
    },
    views: 400,
  },
  {
    id: 4,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.CUSTOMIZE_APPEARANCE.TITLE'),
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Jane' },
    category: {
      slug: 'design',
      icon: '🎨',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.DESIGN.NAME'),
    },
    views: 400,
  },
  {
    id: 5,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.INTEGRATIONS.TITLE'),
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sarah' },
    category: {
      slug: 'integrations',
      icon: '🔗',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.INTEGRATIONS.NAME'),
    },
    views: 2800,
  },
  {
    id: 6,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.PERMISSIONS.TITLE'),
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Alex' },
    category: {
      slug: 'administration',
      icon: '🔐',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.ADMINISTRATION.NAME'),
    },
    views: 1200,
  },
  {
    id: 7,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.FAQ.TITLE'),
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Emily' },
    category: {
      slug: 'content-management',
      icon: '📝',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.CONTENT_MANAGEMENT.NAME'),
    },
    views: 5600,
  },
  {
    id: 8,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.SEARCH.TITLE'),
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'David' },
    category: {
      slug: 'features',
      icon: '🔍',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.FEATURES.NAME'),
    },
    views: 1800,
  },
  {
    id: 9,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.ANALYTICS.TITLE'),
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Rachel' },
    category: {
      slug: 'analytics',
      icon: '📊',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.ANALYTICS.NAME'),
    },
    views: 3200,
  },
  {
    id: 10,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.MULTILINGUAL.TITLE'),
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Carlos' },
    category: {
      slug: 'localization',
      icon: '🌍',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.LOCALIZATION.NAME'),
    },
    views: 900,
  },
  {
    id: 11,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.TUTORIALS.TITLE'),
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Olivia' },
    category: {
      slug: 'education',
      icon: '🎓',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.EDUCATION.NAME'),
    },
    views: 4100,
  },
  {
    id: 12,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.FEEDBACK.TITLE'),
    status: 'draft',
    updatedAt: 1729205669,
    author: { availableName: 'Nathan' },
    category: {
      slug: 'user-engagement',
      icon: '💬',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.USER_ENGAGEMENT.NAME'),
    },
    views: 750,
  },
  {
    id: 13,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.SEO.TITLE'),
    status: 'published',
    updatedAt: 1729205669,
    author: { availableName: 'Sophia' },
    category: {
      slug: 'seo',
      icon: '🚀',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.SEO.NAME'),
    },
    views: 2900,
  },
  {
    id: 14,
    title: t('HELP_CENTER.DEMO_CONTENT.ARTICLES.INTERNAL_KB.TITLE'),
    status: 'archived',
    updatedAt: 1729205669,
    author: { availableName: 'Daniel' },
    category: {
      slug: 'internal-resources',
      icon: '🏢',
      name: t('HELP_CENTER.DEMO_CONTENT.CATEGORIES.INTERNAL_RESOURCES.NAME'),
    },
    views: 1500,
  },
];

export default buildPortalEmptyStateContent;
